import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EmptyObservable } from "rxjs/observable/EmptyObservable";
import { map } from 'rxjs/operators';
import { User } from '../model/user';
import * as jwt_decode from 'jwt-decode';
import 'rxjs/add/operator/publishReplay';
//const alertify = require('alertify');

@Injectable()
export class UserService {
  identity: User;
  identityPromise: Promise<User>;
  options = { headers: new HttpHeaders({ Authorization: localStorage.currentUser }) };

  constructor(
    private http: HttpClient
    ) {/*
      if (localStorage.currentUser) {
        this.getIdentity().subscribe(user => {
          this.identity = user;
        },
        err => {
          this.logout();
          alert('login expired');
        });
      }*/
   }

  login(email: string, password: string): Observable<any> {
    return this.http.post<any>(`https://pure-bastion-78866.herokuapp.com/user/login`, { email, password })
      .pipe(map(response => {
        if (response.user && response.token) {
          localStorage.setItem('currentUser', JSON.stringify(response.token));
          localStorage.setItem('identity', JSON.stringify(response.user[0]));
          this.identity = response.user[0];
          //alertify.success('Logged in!')
        }
        return response;
      }));
  }

  logout() {
    localStorage.removeItem('currentUser');
    localStorage.removeItem('identity');
  }

  forgot(email: string) {
    return this.http.post<any>(`https://pure-bastion-78866.herokuapp.com/user/forgot`, { email: email }).publishReplay(1).refCount();
  }

  reset(id: string, password: string, token: string) {
    return this.http.post<any>(`https://pure-bastion-78866.herokuapp.com/user/reset`, { id: id, password: password, token: token }).publishReplay(1).refCount();
  }

  updateUser(user: User) {
    return this.http.patch<User>(`https://pure-bastion-78866.herokuapp.com/user/update`, user, this.options).publishReplay(1).refCount();
  }

  getIdentity(): Observable<User> {
    this.options = { headers: new HttpHeaders({ Authorization: localStorage.currentUser }) };
    if (localStorage.currentUser) {
      return this.http.get<User>(`https://pure-bastion-78866.herokuapp.com/api/user`, this.options).publishReplay(1).refCount();
    } else {
      return new EmptyObservable<User>();
    }
  }

  addUser(user: User) {
    return this.http.post<User>(`https://pure-bastion-78866.herokuapp.com/user`, user).publishReplay(1).refCount();
  }

  theIdentity() {
    if (localStorage.identity)
    return JSON.parse(localStorage.identity);
    else return null;
  }

  getToken(): string {
    return localStorage.getItem('currentUser');
  }

  getTokenExpirationDate(token: string): Date {
    const decoded = jwt_decode(token);

    if (decoded.exp === undefined) return null;

    const date = new Date(0);
    date.setUTCSeconds(decoded.exp);
    return date;
  }

  isTokenExpired(token?: string): boolean {
    if (!token) token = this.getToken();
    if (!token) return true;

    const date = this.getTokenExpirationDate(token);
    if (date === undefined) return true;
    return !(date.valueOf() > new Date().valueOf());
  }
}



// WEBPACK FOOTER //
// ./src/app/user.service.ts